// extracted by mini-css-extract-plugin
module.exports = {"tagImage":"TagImage_tagImage__NFO9B"};